import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-currencymaster',
  templateUrl: './currencymaster.component.html',
  styleUrls: ['./currencymaster.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CurrencymasterComponent implements OnInit {

  CountryCode: any;
  CurrencyName: string;
  CurrencyCode: string;
  public searchText: string;
  CurrencyExport = [] as any;
  countrys = [];
  countryid: string;
  countrycode: string;
  EditedCurrency = [] as any;
  EditedCurrencyId: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  Status: boolean = false;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'currencyCode', 'currencyName','countrycode', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('CurrencyRead');
    this.vWrite = localStorage.getItem('CurrencyWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }

    this.BindCurrencyGrid();
    this.BindCurrencyExport();
    this.BindCountryDDL();
  }

  BindCountryDDL() {
    var value = this.http.get(environment.apiUrl + 'Currency/GetCountryDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.countrys = data;
          this.countryid = "0";

        }
        else {
        };
      });
  }

  SubmitCurrency() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vCountryId = this.countryid;
    var vcurrencyname = this.CurrencyName;
    var vcurrencycode = this.CurrencyCode;
    debugger;


   
    if (vcurrencycode == undefined || vcurrencycode == "" || vcurrencycode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency Code.";
      return false;
    }
    if (vcurrencycode != undefined || vcurrencycode == "" || vcurrencycode == null) {
      var cncycode = vcurrencycode.split("");
      for(var i=0 ;i<cncycode.length;i++)      
      {        
        if (!(cncycode[i] >= 'a' && cncycode[i] <= 'z' || cncycode[i] >= 'A' && cncycode[i] <= 'Z')) {
          this.isShownError = false;
          this.ErrorMsg = "Please Enter valid Currency Code.";
          return false;
        }
      }      
    }

    if (vcurrencyname == undefined || vcurrencyname == "" || vcurrencyname == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency Name.";
      return false;
    }


    if (vCountryId == undefined || vCountryId == "" || vCountryId == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Country Code.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dCountryid', this.countryid);
    params = params.append('dCurrencyname', this.CurrencyName);
    params = params.append('dCurrencycode', this.CurrencyCode);
    var value = this.http.get(environment.apiUrl + 'Currency/InsertCurrency', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var currencycode = data;
        this.countryid = "";
        this.CurrencyCode = "";
        this.CurrencyName = "";
        this.SuccessMsg = "CurrencyMaster Added."
        this.BindCurrencyGrid();
        this.BindCurrencyExport();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Currency Code Already Exist.";
          return false;
        }
        else {
        }
      });
  }

  EditCurrency(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.EditedCurrency = item;
    var vCurrencyId = this.EditedCurrency.curencyId;
    var vCurrencyCode = this.EditedCurrency.currencyCode;
    var vCurrenyname = this.EditedCurrency.currencyName;
    var vCountryId = this.EditedCurrency.countryId;
    
    this.EditedCurrencyId = vCurrencyId;
    this.CurrencyCode = vCurrencyCode;
    this.CurrencyName = vCurrenyname;
    this.countryid = vCountryId;
    var vStatus = this.EditedCurrency.status;
    debugger;
    if (vStatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
  }


  UpdateCurrency() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownActive =false;
    var vCountryId = this.countryid;
    var vcurrencyname = this.CurrencyName;
    var vcurrencycode = this.CurrencyCode;
    debugger;

    
    if (vcurrencycode == undefined || vcurrencycode == "" || vcurrencycode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency Code.";
      return false;
    }   
    if (vcurrencycode != undefined || vcurrencycode == "" || vcurrencycode == null) {
      var cncycode = vcurrencycode.split("");
      for(var i=0 ;i<cncycode.length;i++)      
      {        
        if (!(cncycode[i] >= 'a' && cncycode[i] <= 'z' || cncycode[i] >= 'A' && cncycode[i] <= 'Z')) {
          this.isShownError = false;
          this.ErrorMsg = "Please Enter valid Currency Code.";
          return false;
        }
      }      
    }

    if (vcurrencyname == undefined || vcurrencyname == "" || vcurrencyname == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency Name.";
      return false;
    }

    if (vCountryId == undefined || vCountryId == "" || vCountryId == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Country Code.";
      return false;
    }

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    params = params.append('iCountryid', this.countryid);
    params = params.append('iCurrencyname', this.CurrencyName);
    params = params.append('iCurrencycode', this.CurrencyCode);
    params = params.append('icurrencyid',this.EditedCurrencyId);
    params = params.append('istatus',vStatus);
    var value = this.http.get(environment.apiUrl + 'Currency/UpdateCurrency', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var currencycode = data;
        this.countryid = "";
        this.CurrencyCode = "";
        this.CurrencyName = "";
        this.SuccessMsg = "CurrencyMaster Updated."
        this.BindCurrencyGrid();
        this.BindCurrencyExport();
        this.isShownSaveBtn = false;
        this.isShownActive = true;
        this.isShownUpdateBtn = true;
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });

  }

  ClearCurrency() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive =true;
    this.isShownUpdateBtn = true;
    this.isShownSaveBtn = false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.CurrencyCode = "";
    this.CurrencyName = "";
    this.countryid = "";
    this.Status = false;
  }

  BindCurrencyGrid() {
    var value = this.http.get(environment.apiUrl + 'Currency/GetCurrencyForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }
  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindCurrencyExport() {
    var value = this.http.get(environment.apiUrl + 'Currency/GetCurrencyForExport').toPromise().then(
      (data: any) => {
        debugger;
        this.CurrencyExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.CurrencyExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'Currency');

    /* save to file */
    XLSX.writeFile(wb, "Currency.xlsx");

  }

}



